import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { SharedModule } from './shared/shared.module';
import { IosPwaPromptComponent } from './ios-pwa-prompt/ios-pwa-prompt.component';
import { SideMenuComponent } from './shared/side-menu/side-menu.component';
import { AreaInspectorComponent } from './area-inspector/area-inspector.component';

import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { UserService } from './services/user.service';
import { AppInstanceService } from './services/app-instance.service';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function initAppInstance(
  userService: UserService,
  appInstanceService: AppInstanceService,
): () => Promise<void> {
  return async () => {
    userService.restoreUserFromLocalStorage();
    await appInstanceService.getAppInstanceSettings();
  };
}

@NgModule({
  declarations: [AppComponent, IosPwaPromptComponent, SideMenuComponent, AreaInspectorComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    SharedModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.sw,
      registrationStrategy: 'registerImmediately',
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: 'fi',
    }),
    GoogleTagManagerModule.forRoot({
      id: 'GTM-PBHSM7D',
    }),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideMessaging(() => getMessaging()),
  ],
  exports: [BrowserModule, BrowserAnimationsModule, HttpClientModule],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initAppInstance,
      deps: [UserService, AppInstanceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
